import type { Action } from '../../store/state/state-manager';

/* action type */
export const DELETE_WORK = 'DELETE_WORK';

/* action creator */
export const deleteWorkAction = (actionPayload: Action['payload']) => {
  return {
    type: DELETE_WORK,
    payload: actionPayload
  };
};
